import {PREBUILD, PREBUILD_OPTIONS, TranslatevideoPrebuild} from "@/constants/translatevideos";

export const isTranslateVideoProject = (prebuild: string) => PREBUILD_OPTIONS.includes(prebuild as TranslatevideoPrebuild);

export const isProofreadStage = (prebuild: string) => prebuild === PREBUILD.PROOFREAD;

export const isExportProofreadStage = (prebuild: string) => prebuild === PREBUILD.EXPORT_PROOFREAD;